import { Button, Divider, Result, Skeleton, Tour } from 'antd';
import API from 'API';
import { NotFound } from 'AppRoute';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { considerStatus, STATUS, STATUS_TEXT } from '../StudentCalendar/TestModal';
import dayjs from 'dayjs';
import { compareArrays, correct_media, formatScore, formatTime } from 'general_function';
import { getScoreColor } from '../StudentCalendar/style_const';
import { Quiz } from 'components/general/StudentExercises';
import { CheckCircleFilled, ClockCircleFilled, CloseCircleFilled, UploadOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { testTypeOptions } from 'components/pages/UniversitySide/UniversityTest';
import { colorSet } from 'const';
import TextWithLatex from 'components/general/TextWithLatex';
import ShowFiles from 'components/general/ShowFiles';
const { useToken } = theme;

const NOW = dayjs();

const showList = [
    { label: "Môn", key: "course_name" },
    { label: "Cách tính điểm", key: "type", render: event => testTypeOptions.find(item => item.value === event.type).label },
    { key: "divider" },
    {
        label: "Thời gian mở", key: "start_time", render: (event) => <>
            {event.start_time.format("DD/MM/YYYY HH:mm:ss")}
        </>
    },
    {
        label: "Thời gian đóng", key: "end_time", render: (event) => <>
            {event.end_time.format("DD/MM/YYYY HH:mm:ss")}
        </>
    },
    { key: "divider" },
    { label: "Số lượng câu hỏi", key: "number_of_quizzes" },
    {
        label: "Thời gian làm bài", key: "duration_time", render: (event) => <>
            {formatTime(event.time)}
        </>
    },
    { key: "divider" },
    { label: "Số lần làm tối đa", key: "limit" },
    { label: "Số lần bạn đã làm", key: "done", render: (event) => event.results.length },
    { key: "divider" },
    {
        label: "Điểm sau cùng", key: "score", render: (event) => <span style={{
                color: getScoreColor(event.result)
            }}>{formatScore(event.result, event.end_time, true)}</span>,
    },
    {
        label: "Trạng thái", key: "status", render: (event, status) => {
            return <>
                <span className={`test-status ${STATUS[status]}`}>
                    {STATUS_TEXT[status]}
                </span>
            </>
        }
    },
]


const QUIZ_RESULT = {};
const LOCAL_PREFIX = "student_release_result"

function saveStudentReleaseResult(id, quiz_id, answer) {
    const result_obj = getStudentReleaseResult(id);
    result_obj[quiz_id] = answer;
    localStorage.setItem(`${LOCAL_PREFIX}_${id}`, JSON.stringify(result_obj));
}

function getStudentReleaseResult(id) {
    if (id in QUIZ_RESULT) return QUIZ_RESULT[id];
    var result = localStorage.getItem(`${LOCAL_PREFIX}_${id}`);
    result = result === null ? {} : JSON.parse(result);
    QUIZ_RESULT[id] = result;
    return result;
}

function StudentReleaseStatus({ studentRelease, currentStudentRelease, doTest, release, now, gettingQuiz }) {
    if (studentRelease.score !== null) {
        return <></>
    }
    if (studentRelease.id === currentStudentRelease?.id) {
        return <span className="test-status during">
            Đang làm bài
        </span>
    }
    if (studentRelease.created_at.add(release.time, "second").isBefore(now)) {
        return <span className="test-status not-do">
            Bạn đã không nộp bài
        </span>
    }
    return <Button type='primary' disabled={gettingQuiz} loading={gettingQuiz} onClick={() => doTest(studentRelease)}>
        Tiếp tục làm bài
    </Button>
}

export default function StudentTest() {
    const { id } = useParams();
    const [now, setNow] = useState(NOW);
    useEffect(() => {
        const internal = setInterval(() => { setNow(dayjs()); }, 1000);
        return () => clearInterval(internal);
    }, [])
    const [release, setRelease] = useState(null);
    const [studentRelease, setStudentRelease] = useState(null);
    const [loading, setLoading] = useState(true);
    const [quizzes, setQuizzes] = useState(null);
    const [gettingQuiz, setGettingQuiz] = useState(false);
    const [openTour, setOpenTour] = useState(false);
    const timeRef = useRef();
    const resultRef = useRef();
    const [submitting, setSubmitting] = useState(false);
    const { token } = useToken();

    useEffect(() => {
        if (!release) return;
        document.title = release.title;
    },[release])

    useEffect(() => {
        async function getData() {
            try {
                const response = await API.get(`student/test-releases/${id}/`);
                response.data.start_time = dayjs(response.data.start_time);
                response.data.end_time = dayjs(response.data.end_time);
                for (const result of response.data.results) {
                    result.created_at = dayjs(result.created_at);
                }
                setRelease(response.data);
                if (response.data.type === 2 && response.data.results.length > 0 && response.data.results[0].score !== null) {
                    for (const quiz of response.data.quizzes) {
                        for (const image of quiz.images) {
                            image.file = correct_media(image.file);
                        }
                    }
                    setQuizzes(response.data.quizzes);
                }
                setLoading(false);
            } catch (e) {
                if (e.response?.status === 404) {
                    setLoading(false);
                }
                console.log(e);
            }
        }
        getData();
    }, [id])
    const status = useMemo(() => release && considerStatus(release, dayjs()), [release])

    const submitTest = useCallback((quizzes, studentRelease) => {
        async function postData() {
            try {
                setSubmitting(true);
                const response = await API.post(`student/submit-test/`, {
                    student_test_release_id: studentRelease.id,
                    answers: quizzes.map(quiz => ({
                        id: quiz.id, answers: quiz.student_answer?.answers
                    }))
                })
                response.data.created_at = dayjs(response.data.created_at);
                setStudentRelease(response.data);
                setRelease(release => {
                    const index = release.results.findIndex(item => item.id === response.data.id);
                    release.results[index] = response.data;
                    release.results = [...release.results];
                    if (release.type === 0) {
                        if (release.result === null || release.result < response.data.score) {
                            release.result = response.data.score;
                        }
                    } else if (release.type === 1) {
                        release.result = Math.floor((release.result*(release.results.length - 1) + response.data.score)/release.results.length);
                    } else if (release.type === 2) {
                        release.result = 1000;
                    }
                    return { ...release }
                })
                if (release.type === 2) {
                    setQuizzes(quizzes => {
                        for (const quiz of release.quizzes) {
                            quiz.student_answer = quizzes.find(item => item.id === quiz.id)?.student_answer;
                        }
                        return release.quizzes;
                    });
                } else {
                    setQuizzes(null);
                }
                setTimeout(() => {
                    resultRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
                },100)
            } catch (e) {
                console.log(e);
            } finally {
                setSubmitting(false);
            }
        }
        postData();
    }, [release])

    const doTest = useCallback((studentRelease) => {
        async function getData() {
            try {
                setGettingQuiz(true);
                const response = await API.post(`student/start-test/`, {
                    release_id: release.id,
                    student_test_release: studentRelease?.id
                })
                response.data.student_test_release.created_at = dayjs(response.data.student_test_release.created_at);
                setStudentRelease(response.data.student_test_release);
                if (studentRelease) {
                    const quiz_result = getStudentReleaseResult(studentRelease.id);
                    for (const quiz of response.data.quizzes) {
                        if (quiz.id in quiz_result) {
                            quiz.student_answer = { answers: quiz_result[quiz.id] }
                        }
                    }
                }
                for (const quiz of response.data.quizzes) {
                    for (const image of quiz.images) {
                        image.file = correct_media(image.file);
                    }
                }
                setQuizzes(response.data.quizzes);
                if (!studentRelease) {
                    setRelease(release => ({
                        ...release,
                        results: [...release.results, response.data.student_test_release]
                    }))
                }
                if (localStorage.getItem("openTestTour") === null) {
                    setOpenTour(true);
                    localStorage.setItem("openTestTour", "yep");
                }
            } catch (e) {
                console.log(e);
            }
            setGettingQuiz(false);
        }
        getData();
    }, [release])

    const seconds = useMemo(() => {
        if (studentRelease === null) {
            return 0;
        }
        const result = studentRelease.created_at.add(release.time, "second").diff(now, 'second');
        if (result === 0 && studentRelease.score === null) {
            submitTest(quizzes, studentRelease);
        }
        return Math.max(result, 0);
    }, [now, studentRelease, release, quizzes, submitTest])

    return loading ? <Skeleton active /> : release === null ? <NotFound />
            : <>
                <div style={{ position: "relative" }}>
                    <h4>{release.title}</h4>
                    <div style={{ marginBottom: 5 }}>
                        {showList.map((item, index) => item.key === "divider"
                            ? <Divider key={`divider_${index}`} style={{ marginBottom: 5, marginTop: 5 }} />
                            : <div key={item.key}>
                                <b>{item.label}:</b> {item.render ? item.render(release, status) : release[item.key]}
                            </div>)}
                    </div>
                    <div>
                        {status === 1 && release.results.length < release.limit && <Button type='primary' disabled={gettingQuiz} loading={gettingQuiz} onClick={() => doTest()}>
                            Bắt đầu lượt làm bài mới
                        </Button>}
                    </div>
                    <Divider />
                    {release.results.lenght === 0 && <>Bạn chưa làm bài lần nào</>}
                    {release.results.map((item, index) => <>
                        <div>
                            <b>Thời gian bắt đầu:</b> {item.created_at.format("DD/MM/YYYY HH:mm:ss")} <br />
                            <b>Thời gian kết thúc:</b> {item.created_at.add(release.time, "second").format("DD/MM/YYYY HH:mm:ss")} <br />
                            <b>Điểm số:</b>
                            {item.score === null ? <> Không có</> : <span style={{
                                color: getScoreColor(item.score)
                            }}> {formatScore(item.score)}</span>}
                            <br />
                            <StudentReleaseStatus
                                studentRelease={item}
                                currentStudentRelease={studentRelease}
                                doTest={doTest}
                                release={release}
                                now={now}
                                gettingQuiz={gettingQuiz}
                            />
                        </div>
                        {(index !== release.results.length - 1) && <Divider style={{ margin: 3 }} />}
                    </>)}
                    <Divider />
                    <>
                        {studentRelease !== null && studentRelease.score === null &&
                            <div style={{
                                display: "inline-block",
                                backgroundColor: token.colorPrimary,
                                color: "white",
                                padding: "3px 7px",
                                borderRadius: 5,
                                fontSize: 15,
                                minWidth: 80,
                                textAlign: "center",
                                zIndex: 10000,
                                position: "fixed", bottom: 15, right: 10,
                            }} ref={timeRef}>
                                {formatTime(seconds, false)} <ClockCircleFilled />
                            </div>
                        }
                        {studentRelease !== null && studentRelease.score !== null && <div ref={resultRef}>
                            <Result
                                status="success"
                                title="Chúc mừng"
                                subTitle={<>
                                    Bạn đã hoàn thành bài kiểm tra với điểm số<br /><span style={{
                                        color: getScoreColor(studentRelease.score),
                                        fontSize: 40
                                    }}>
                                        {formatScore(studentRelease.score)}
                                    </span>
                                </>}
                            />
                        </div>}
                        {quizzes !== null && <div>
                            {quizzes.map(quiz => <div className="quiz-div" key={quiz.id}>
                                <div>
                                    <TextWithLatex text={quiz.question}/>
                                </div>
                                <ShowFiles files={quiz.images}/>
                                {quiz.correct_answers[0] !== -1 && (
                                    quiz.student_answer?.answers && (compareArrays(quiz.correct_answers, quiz.student_answer.answers)) ? 
                                    <div style={{ color: colorSet["high"], marginBottom: 3 }}>
                                        <CheckCircleFilled /> Bạn đã trả lời <b>đúng</b> câu hỏi này
                                    </div> :
                                    <div style={{ color: colorSet["low"], marginBottom: 3 }}>
                                        <CloseCircleFilled /> Bạn đã trả lời <b>sai</b> câu hỏi này
                                    </div>
                                )}
                                <Quiz disable={release.quizzes === quizzes} data={quiz} setQuiz={setQuizzes} onChange={(value) => {
                                    saveStudentReleaseResult(studentRelease.id, quiz.id, value);
                                }} />
                            </div>)}
                            {release.quizzes !== quizzes && <Button type="primary" style={{ marginTop: 5 }}
                                loading={submitting} disabled={submitting}
                                onClick={() => submitTest(quizzes, studentRelease)}
                            >
                                Nộp bài <UploadOutlined />
                            </Button>}
                        </div>}
                    </>
                </div>
                <Tour open={openTour} onClose={() => setOpenTour(false)} steps={[
                    {
                        title: "Lưu ý",
                        description: 'Thời gian làm bài của bạn là có giới hạn',
                        target: () => timeRef.current,
                        nextButtonProps: {
                            children: "Đóng"
                        },
                    }
                ]} />
            </>
}
